import React, { Dispatch, SetStateAction } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface Props {
  label?: string;
  placeholder?: string;
  value: number;
  setValue: (value: number) => void;
  readOnly?: boolean;
  min?: number;
  max?: number;
  step?: number;
  classname?: string;
}

function NumberInput({
  label,
  placeholder,
  value,
  setValue,
  readOnly,
  min,
  max,
  step,
  classname,
}: Props) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <Label>{label}</Label>
      <Input
        placeholder={placeholder}
        type="number"
        value={value}
        onChange={(e) => setValue(e.target.valueAsNumber)}
        readOnly={readOnly ?? false}
        min={min ? min : undefined}
        max={max ? max : undefined}
        step={step ? step : undefined}
        className={classname}
      />
    </div>
  );
}

export default NumberInput;
